/*
 *
 * HubspotVerify reducer
 *
 */
import produce from 'immer';
import { VERIFY_HUBSPOT } from './constants';

export const initialState = {
  isVerify: true,
  error: false,
};

/* eslint-disable default-case, no-param-reassign */
const hubspotVerifyReducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case VERIFY_HUBSPOT.START:
        draft.isVerify = true;
        draft.error = false;
        break;

      case VERIFY_HUBSPOT.SUCCESS:
        draft.isVerify = false;
        draft.error = false;
        break;

      case VERIFY_HUBSPOT.ERROR:
        draft.isVerify = false;
        draft.error = true;
        break;
    }
  });
};

export default hubspotVerifyReducer;
